// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`XsellProducts general snapshot 1`] = `
<div class="xsell-products">
  <div class="products-wrap">
    <div class="md-fixed-width-tweak-upper lg-fixed-width-tweak-upper"></div>
  </div>
  <div class="continue-to-bag text-center"><button class="back btn-reset arrow-link xs-f-small lg-f-medium max-at-tweak"><span class="icon-arrow-back xs-f-xlarge max-at-tweak"><span class="ada-tooltip">arrow back icon</span></span><span class="xs-f-small lg-f-medium max-at-tweak">&nbsp;Back</span></button><a href="/cart" target="_self" data-mr-ass="color-pro-continue" class="mr-btn btn-inverse btn-fixed-width xs-f-xsmall max-at-tweak">continue to bag</a></div>
</div>
`;
